import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { __API_URL__ } from "../SERVER_URL";

const fetchTrialForPatient = async (patientId, trialId) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (trialId) params.append("trial_id", trialId);

  const response = await axios.get(
    `${__API_URL__}/api/photos/get_trial_for_patient/${patientId}/?${params.toString()}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return response.data;
};

const useGetTrialForPatient = ({ patientId, trialId, enabled = true }) => {
  return useQuery({
    queryKey: ["trial_for_patient", patientId, trialId],
    queryFn: () => fetchTrialForPatient(patientId, trialId),
    enabled: enabled && !!patientId,
  });
};

export default useGetTrialForPatient;
